import { FC, useEffect } from 'react'
import { Modal } from 'antd'
import shallow from 'zustand/shallow'

import { useLocales } from '../../../graphql/profiles/locales'
import { LoadingAndErrors } from '../LoadingAndErrors'
import { SettingsModalHeader } from './SettingsModalHeader'
import { SettingsModalContent } from './SettingsModalContent'
import { useSettingsModalStore } from './SettingsModalStore'
import { SettingsModalFooter } from './SettingsModalFooter'

export const SettingsModal: FC = () => {
  const [isModalOpened, setLocales] = useSettingsModalStore((state) => [state.isModalOpened, state.setLocales], shallow)

  const { data, error, loading } = useLocales()

  useEffect(() => {
    if (!!data && !!data.locales) {
      setLocales(data.locales)
    }
  }, [data, setLocales])

  return (
    <Modal
      title={<SettingsModalHeader />}
      visible={isModalOpened}
      closable={false}
      footer={<SettingsModalFooter />}
      destroyOnClose={true}
      className="per-modal per-modal--large"
    >
      {loading || !!error ? (
        <LoadingAndErrors isLoading={loading} hasNoData={!data || !data.locales} error={error} showSpinner />
      ) : (
        <SettingsModalContent />
      )}
    </Modal>
  )
}
